import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-11d37fce"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "navbar-menu"
};
const _hoisted_2 = {
  class: "menu-list"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "menu-item"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://www.comentropy.org/"
}, "首页")], -1));

import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'navbar-menu',

  setup(__props, {
    expose: __expose
  }) {
    const route = useRoute();
    const router = useRouter();
    const drawerVisible = ref(false);

    const handleTo = path => {
      router.push(path);
      drawerVisible.value = false;
    };

    __expose({
      drawerVisible
    });

    return (_ctx, _cache) => {
      const _component_el_drawer = _resolveComponent("el-drawer");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_drawer, {
        modelValue: drawerVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => drawerVisible.value = $event),
        "with-header": false,
        size: "200px",
        direction: "ltr"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
          class: _normalizeClass(['menu-item', {
            active: _unref(route).path
          }]),
          onClick: _cache[0] || (_cache[0] = $event => handleTo('/item-list'))
        }, " 下载中心 ", 2)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};